import { atom } from 'jotai'

export const editingRowIdAtom = atom<string | null>(null)

// When true, the current editing row cannot be dismissed by clicking outside
export const editingRowLockedAtom = atom(false)

export const isEditingEnabledAtom = atom(true)
